<template>
    <div class="favourite" :class="inline ? 'd-inline-block' : ''">
        <div v-if="active" @click="unfavourite()">
            <img src="/icons/star-icon-yellow.svg" alt="favourite" >
            <span v-if="isClub">Favourite</span>
        </div>
        <div v-else  @click="favourite()">
            <img :src="image" alt="favourite">
            <span v-if="isClub">Add club to favourites</span>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'


export default {
    data() {
        return {
            list: null,
            active: false,
        }
    },

    props: [
        'listUrl', 'favouriteUrl', 'hashid', 'isClub', 'inline', 'listProp',
    ],


    computed: {
        image() {
            return this.isClub ?
            '/icons/star-icon-grey.svg' :
            '/icons/star-icon-black.svg';
        }
        
    },

    created() {
    },

    mounted() {
        if (!this.listProp) {
            this.getList();
        } else {
            this.list = this.listProp;
            this.checkIfFavourited();
        }
    },

    watch: {
    },

    methods: {
        checkIfFavourited() {
            this.list.forEach(element => {
                if(element['id'] === this.hashid) {
                    this.active = true;
                }
            });
        },
        getList() {
            axios
                .get(this.listUrl,
                    {
                        params: {
                            
                        }
                    }
                )
                .then(response => {
                    this.list = response.data.data;
                    this.checkIfFavourited();

                })
                .catch(error => {
                    console.log(error);
                });

        },
        favourite() {
            axios
                .post(this.favouriteUrl,
                    {
                        params: {
                            
                        }
                    }
                )
                .then(response => {
                    this.active = true;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        unfavourite() {
            axios
                .delete(this.favouriteUrl,
                    {
                        params: {
                            
                        }
                    }
                )
                .then(response => {
                    this.active=false
                })
                .catch(error => {
                    console.log(error);
                });
        }
    },
}
</script>
